<template>
  <div class="suggest-doctor-testimonials">
    <div class="testimonials-heading text-center">
      تجربه مراجعان از مشاوره آنلاین
    </div>
    <div class="testimonials-slider">
      <v-btn
          icon
          class="nav-btn"
          :aria-label="$vuetify.rtl ? 'اسلاید بعدی' : 'اسلاید قبلی'"
          @click="goPrev"
      >
        <span class="nav-btn-char">&lt;</span>
      </v-btn>
      <div class="slides-card">
        <transition name="testimonial-fade" mode="out-in">
          <v-row
              :key="currentSlide"
              class="slides-row ma-0"
              align="center"
          >
            <v-col
                v-for="(item, idx) in currentPair"
                :key="`${currentSlide}-${idx}`"
                cols="12"
                sm="6"
                class="pa-2 pa-sm-3 d-flex align-center"
            >
              <div class="testimonial-block text-right">
                <div class="testimonial-name">{{ item.name }}، {{ item.age }} ساله</div>
                <blockquote class="testimonial-quote">«{{ item.quote }}»</blockquote>
              </div>
            </v-col>
          </v-row>
        </transition>
      </div>
      <v-btn
          icon
          class="nav-btn"
          :aria-label="$vuetify.rtl ? 'اسلاید قبلی' : 'اسلاید بعدی'"
          @click="goNext"
      >
        <span class="nav-btn-char">&gt;</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
const AUTO_INTERVAL_MS = 4000

export default {
  name: 'SuggestDoctorLoadingTestimonials',
  data() {
    return {
      currentSlide: 0,
      autoTimer: null,
      items: [
        {
          name: 'الهام',
          age: '۲۹',
          quote: 'اولش فکر نمی‌کردم مشاوره آنلاین بتونه اینقدر کمک‌کننده باشه، ولی خیلی راحت‌تر از چیزی بود که تصور می‌کردم و واقعاً حالم بهتر شد.',
        },
        {
          name: 'مهدی',
          age: '۳۴',
          quote: 'به خاطر مشغله زیاد هیچ‌وقت فرصت مراجعه حضوری نداشتم، مشاوره آنلاین باعث شد بالاخره درمانم رو شروع کنم.',
        },
        {
          name: 'سارا',
          age: '۲۶',
          quote: 'اینکه از خونه و در فضای امن خودم با روانشناس صحبت کردم، باعث شد خیلی راحت‌تر حرف بزنم.',
        },
        {
          name: 'امیر',
          age: '۳۱',
          quote: 'جلسات آنلاین برام خیلی کاربردی بود، هم در زمان صرفه‌جویی شد هم حس کردم ارتباط خوبی با درمانگرم برقرار کردم.',
        },
        {
          name: 'نازنین',
          age: '۲۸',
          quote: 'مدت‌ها اضطراب داشتم و مراجعه رو عقب می‌انداختم، ولی آنلاین بودنش باعث شد سریع‌تر اقدام کنم.',
        },
        {
          name: 'رضا',
          age: '۳۷',
          quote: 'اوایل مردد بودم، اما بعد از اولین جلسه فهمیدم کیفیت مشاوره کاملاً قابل اعتماد و حرفه‌ایه.',
        },
        {
          name: 'فاطمه',
          age: '۳۲',
          quote: 'برای من که خارج از شهر زندگی می‌کنم، این سرویس واقعاً نجات‌بخش بود و دسترسی به روانشناس رو خیلی راحت کرد.',
        },
        {
          name: 'علی',
          age: '۳۰',
          quote: 'بدون استرس رفت‌وآمد و معطلی، تونستم منظم جلساتم رو ادامه بدم و این خیلی مهم بود.',
        },
        {
          name: 'زهرا',
          age: '۲۷',
          quote: 'احساس می‌کردم کسی واقعاً حرف‌هام رو می‌شنوه. تجربه مشاوره آنلاین خیلی بهتر از انتظارم بود.',
        },
        {
          name: 'محمد',
          age: '۳۵',
          quote: 'شروع کردن همیشه سخت بود، ولی آنلاین بودن جلسات باعث شد اون قدم اول رو راحت‌تر بردارم.',
        },
      ],
    }
  },
  computed: {
    slidePairs() {
      const pairs = []
      for (let i = 0; i < this.items.length; i += 2) {
        pairs.push(this.items.slice(i, i + 2))
      }
      return pairs
    },
    currentPair() {
      return this.slidePairs[this.currentSlide] || []
    },
    pairCount() {
      return this.slidePairs.length
    },
  },
  mounted() {
    this.startAuto()
  },
  beforeDestroy() {
    this.stopAuto()
  },
  methods: {
    goNext() {
      this.currentSlide = (this.currentSlide + 1) % this.pairCount
      this.restartAuto()
    },
    goPrev() {
      this.currentSlide = (this.currentSlide - 1 + this.pairCount) % this.pairCount
      this.restartAuto()
    },
    startAuto() {
      this.stopAuto()
      this.autoTimer = setInterval(() => {
        this.goNext()
      }, AUTO_INTERVAL_MS)
    },
    stopAuto() {
      if (this.autoTimer) {
        clearInterval(this.autoTimer)
        this.autoTimer = null
      }
    },
    restartAuto() {
      this.startAuto()
    },
  },
}
</script>

<style scoped>
.suggest-doctor-testimonials {
  direction: rtl;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 28px;
}

.testimonials-heading {
  font-size: 15px;
  font-weight: 600;
  color: #616161;
  margin-bottom: 12px;
}

.testimonials-slider {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 4px;
}

.slides-card {
  flex: 1;
  min-width: 0;
  border-radius: 12px;
  border: 1px solid #E0E0E0;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  min-height: 200px;
  padding: 16px 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
}

.slides-row {
  width: 100%;
  flex: 0 0 auto;
}

.nav-btn {
  flex-shrink: 0;
  align-self: center;
  width: 40px !important;
  height: 40px !important;
  background: #39C990 !important;
  box-shadow: none !important;
  color: #fff !important;
}

.nav-btn:hover {
  background: #30a778 !important;
}

.nav-btn-char {
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  font-family: en-num, sans-serif;
}

.testimonial-block {
  width: 100%;
}

.testimonial-name {
  font-size: 15px;
  font-weight: 700;
  color: #39C990;
  margin-bottom: 8px;
}

.testimonial-quote {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.65;
  color: #424242;
  font-style: normal;
}

.testimonial-fade-enter-active,
.testimonial-fade-leave-active {
  transition: opacity 0.2s ease;
}

.testimonial-fade-enter,
.testimonial-fade-leave-to {
  opacity: 0;
}

@media (max-width: 599px) {
  .suggest-doctor-testimonials {
    max-width: 100%;
    padding-left: 4px;
    padding-right: 4px;
  }

  .testimonials-slider {
    gap: 2px;
  }

  .nav-btn {
    width: 36px !important;
    height: 36px !important;
  }

  .slides-card {
    min-height: 240px;
    padding: 12px 8px;
    margin-bottom: 100px;
  }

  .testimonial-quote {
    font-size: 13px;
  }
}
</style>
